import { colorPalette } from '../../colorPalette';
export const global = {
    display: 'flex',
    borderRadius: '30px',
    flexDirection: 'row',
    justifyContent: 'center',
    width: 'fit-content',
    alignItems: 'center',
    gap: '5px',
    height: '3.8rem',
    padding: '1rem 1.2rem',
};
export const clubR = {
    display: 'flex',
    alignItems: 'center',
    fontSize: '1.4rem',
};
export const clubRSwitch = {
    display: 'flex',
    alignItems: 'center',
    fontSize: '1.4rem',
    '& > * ': {
        padding: 0,
        marginRight: '0.5rem',
    },
};
export const amount = {
    color: colorPalette.red800,
    fontSize: '14px',
    fontWeight: 700,
};
export const cagnotte = (isChecked) => (Object.assign(Object.assign({}, global), { backgroundColor: isChecked ? colorPalette.red100 : colorPalette.gray100, justifyContent: 'space-between', display: 'flex', '&:hover': { backgroundColor: isChecked ? colorPalette.red200 : colorPalette.gray200 }, '&:active': { backgroundColor: isChecked ? colorPalette.red300 : colorPalette.gray300 }, '&:focus': { border: `1px solid ${colorPalette.lightBlue800} ` } }));
export const cagnotteDisabled = () => (Object.assign(Object.assign({}, global), { backgroundColor: colorPalette.gray100, filter: 'grayscale(90%)' }));
